import { render, staticRenderFns } from "./ActiveCustomersSearch.vue?vue&type=template&id=054024fc&"
import script from "./ActiveCustomersSearch.vue?vue&type=script&lang=js&"
export * from "./ActiveCustomersSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports